import React from 'react';
import Page from '../../components/Page';
import seo from '../../constants/seo';

const NonResNepali = () => (
  <Page {...seo.nr}>
    <h2 className="mt-0 pt-0">NON-RESIDENTIAL NEPALIS</h2>
    <p className="mb-1">Hello there,</p>
    <p>
      You guys are the best ambassadors Nepal has, and we understand you wish to contribute
      to Nepal in any way you can.
    </p>
    <p>
      Here is how HoneyGuide can help you do that:
      <ol>
        <li>
          Promote Nepal by introducing Nepal and Everest through the high-quality and
          no-strings-attached information in HoneyGuide’s Website and Mobile Apps.
        </li>
        <li>
          Bring your Friends Home by Selling your own Trek. HoneyGuide can handle all the
          logistics and payments.
        </li>
        <li>
          Refer a Friend and Make Money. Give Promo Codes to your friends so they Get
          Discounts and you Make a Service Fee.
        </li>
        <li>
          Show to the World that Nepal is not just an impoverished nation but also a country
          where innovative technology companies are taking on difficult problems.
        </li>
      </ol>
    </p>
    <p>
      Key Features of Working with HoneyGuide are:
      <ol>
        <li>
          We say it as we see it, no strings attached. Check out our Trekking in Nepal
          Mobile App to find out.{' '}
          <a href="https://play.google.com/store/apps/details?id=com.trekkinginnepal.app&hl=en">
            Android
          </a>{' '}
          and{' '}
          <a href="https://itunes.apple.com/la/app/trekking-in-nepal/id1112263577?mt=8">
            iOS
          </a>
        </li>
        <li>
          HoneyGuide can assist you to craft an amazing trekking experience, feature it in
          our platform, manage online payments and manage all logistical support. All you
          need to do is take care of your friends.
        </li>
        <li>Sign up for Promo Codes in HoneyGuide and pass it on to your friends.</li>
      </ol>
    </p>
    <p>Let us all work together to transform Nepal one Trek a Time.</p>
    <p>
      If you have any questions, please contact: <br />
      Ashish Shrestha <br />
      +977-9841370673 <br />
      <a href="mailto:honeyhunter@honeyguideapps.com">honeyhunter@honeyguideapps.com</a>
    </p>
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLScsImc8En9O6B91Hc3tnz-uxW7yfwTqDOTNc34lbf0fACTGsA/viewform?embedded=true"
      width="100%"
      height="1089"
      frameBorder="0"
      marginHeight="0"
      marginWidth="0"
      title="Non Resident Nepali"
    >
      Loading...
    </iframe>

    <p>
      <strong>About HoneyGuide</strong> <br />
      HoneyGuide is a technology company that helps men and mountains meet more often. While
      we go about it, we are constantly guided by our belief that:
      <ol>
        <li>
          Providing Trekkers with No-strings attached and Accurate Information will make our
          mountains safer and help more people enjoy the thrills of a rarefied atmosphere.
        </li>
        <li>A Trekker should have the power to run a trek the way she sees fit easily.</li>
        <li>
          Connecting Local Service Providers with Trekkers will lead to a more equitable
          distribution of tourism dividends and increase service levels faster.
        </li>
      </ol>
    </p>
  </Page>
);

export default NonResNepali;



// WEBPACK FOOTER //
// ./src/screens/Partners/NonResNepali.jsx